import clsx from 'clsx'
import {Link, useNavigate} from 'react-router-dom'
import type {ReactNode} from 'react'
import {useHasModule} from '../../../../app/modules/auth'

type Props = {
  to: string
  moduleSlug: string
  icon: string
  children: ReactNode
  className?: string
}

const UPGRADE_TOOLTIP =
  'Este recurso está disponível apenas em planos superiores. Atualize seu plano para acessá-lo.'

export function SettingsModuleLink({to, moduleSlug, icon, children, className}: Props) {
  const navigate = useNavigate()
  const hasAccess = useHasModule(moduleSlug)

  if (hasAccess) {
    return (
      <Link to={to} className={clsx('menu-link px-5', className)}>
        <i className={clsx(icon, 'menu-icon')}></i>
        {children}
      </Link>
    )
  }

  return (
    <button
      type='button'
      className={clsx(
        'menu-link without-sub disabled px-5 border-0 bg-transparent w-100 text-start d-flex align-items-center settings-module-link--locked',
        className
      )}
      style={{cursor: 'not-allowed'}}
      aria-label={UPGRADE_TOOLTIP}
      data-tooltip={UPGRADE_TOOLTIP}
      onClick={() => navigate('/billings')}
    >
      <i className={clsx(icon, 'menu-icon')}></i>
      {children}
      <i className='bi bi-lock ms-auto flex-shrink-0'></i>
    </button>
  )
}
